import { render, staticRenderFns } from "./result-search.orders-tabs.vue?vue&type=template&id=35733d98&"
import script from "./result-search.orders-tabs.vue?vue&type=script&lang=ts&"
export * from "./result-search.orders-tabs.vue?vue&type=script&lang=ts&"
import style0 from "./result-search.orders-tabs.vue?vue&type=style&index=0&id=35733d98&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports